import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import transparentlogo from '../assets/img/transparentlogo.svg';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

 const scrollToContact = () => {
    const contactSection = document.getElementById("connect");

    if (contactSection){
      contactSection.scrollIntoView({
        behavior: "smooth",
        block:"start",
      });
    }
  };

  return (
    <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="/">
          <img src={transparentlogo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
            <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
            <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>Projects</Nav.Link>
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/kabelo-gaogomotswe-8284a8348" target="_blank" rel="noreferrer"><img src={navIcon1} alt="LinkedIn profile" /></a>
              <a href="https://web.facebook.com/profile.php?id=100005386905759" target="_blank" rel="noreferrer"><img src={navIcon2} alt="Facebook profile" /></a>
              <a href="https://www.instagram.com/kabelo.ng/" target="_blank" rel="noreferrer"><img src={navIcon3} alt="Instagram profile" /></a>
            </div>
            <button className="vvd" onClick={scrollToContact}><span>Let’s Connect</span></button>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
